import * as React from "react";

function SvgIcons8FontSize(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M9.629 5L3 23.83V27h2v-2.83L6.82 19h7.36L16 24.17V27h2v-3.17L11.371 5H9.63zm.871 3.547L13.477 17H7.523L10.5 8.547zM23.5 17a3.515 3.515 0 00-3.5 3.5v3c0 1.921 1.579 3.5 3.5 3.5 1.058 0 1.98-.503 2.623-1.254C26.853 26.511 27.868 27 29 27v-2c-1.117 0-2-.883-2-2v-3h-.102c-.254-1.678-1.654-3-3.398-3zm0 2c.84 0 1.5.66 1.5 1.5v3c0 .84-.66 1.5-1.5 1.5s-1.5-.66-1.5-1.5v-3c0-.84.66-1.5 1.5-1.5z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8FontSize);
